// OrdersMain.tsx
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import OrderTable from "./OrderTable";
import { SearchAndFilterToolbar, StatusBar } from "../common";
import PageBodyWrapper from "../../components/PageBodyWrapper";
import useApi from "../../api";
import enumChoice from "../../enum";
import { useQuery, gql } from "@apollo/client";
import {GraphQLPagination} from "../common";

import { getQueryVariables } from "../../utils";
import OrderFilter from "./orderFilter";
import CreateOrderForm from "./create/CreateOrderForm";

const GET_ORDERS = gql`
  query GetOrders(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $status: String
    $minOrderValue: Decimal
    $maxOrderValue: Decimal
    $createdAtAfter: Date
    $createdAtBefore: Date
  ) {
    orders(
      first: $first
      last: $last
      after: $after
      before: $before
      status: $status
      minOrderValue: $minOrderValue
      maxOrderValue: $maxOrderValue
      createdAtAfter: $createdAtAfter
      createdAtBefore: $createdAtBefore
    ) {
      edges {
        node {
          alias
          status
          dbId
          humanizeTotalPrice
          createdAt
          paymentMethod
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

function OrdersMain() {
  const [openOrderFilterModal, setOpenOrderFilterModal] = useState(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const api = useApi();

  const { data, loading, error, refetch } = useQuery(GET_ORDERS, {
    variables: getQueryVariables(searchParams),
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (!searchParams.get("first") && !searchParams.get("last")) {
      setSearchParams({ first: "20" });
    }
  }, []);


  const fetchOrders = () => {
    refetch();
  }

  return (
    <PageBodyWrapper>
      <StatusBar
        onButtonClick={() => setOpenModal(!openModal)}
        statusList={enumChoice.orderStatus}
        buttonLabel="Create Order"
        fieldName="status"
      />

      <SearchAndFilterToolbar
        onFilterOpen={() => setOpenOrderFilterModal(!openOrderFilterModal)}
        onRefresh={fetchOrders}
        onClearFilters={() => ({})}
        startDateKey={"createdAtAfter"}
        endDateKey={"createdAtBefore"}
      />


      {openOrderFilterModal && <OrderFilter  onClose={() => setOpenOrderFilterModal(false)} />}
      
      <div className="px-1">
        <OrderTable orders={data?.orders?.edges || []} />
      </div>

      <GraphQLPagination 
        edges={data?.orders?.edges || []}
        pageInfo={data?.orders?.pageInfo || {}}
      />

    {openModal && <CreateOrderForm isOpen={openModal} onClose={()=>setOpenModal(!openModal)}/>}


    </PageBodyWrapper>
  );
}

export default OrdersMain;